import { Cookie as CookieNames, type OddsFormat } from '@ps/web-core-enums';
import Cookies from 'universal-cookie';

const TEN_YEARS = 10 * 365 * 24 * 60 * 60;

export function setOddsFormatCookie(format: OddsFormat | null | undefined) {
  const cookies = new Cookies();
  cookies.set(CookieNames.ODDS_FORMAT, format, {
    path: '/',
    maxAge: TEN_YEARS
  });
}
